import gql from 'graphql-tag';

export const CreateFabricBlogpostMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation CreateFabricBlogpostMutation(
			$spaceKey: String!
			$returnSpaUrl: Boolean!
			$title: String
		) @experimental {
			experimentalCreateFabricBlogpost(
				spaceKey: $spaceKey
				returnSpaUrl: $returnSpaUrl
				title: $title
			) {
				links {
					draftUrl
				}
			}
		}
	`;
